<template>
  <abf-container>
    <v-layout>
      <v-flex xs12 pt-0>
        <v-card>
          <v-card-title>
            <v-avatar class="secondary">
              <v-icon dark>people</v-icon>
            </v-avatar>
            <div class="ml-3">
              <h4 class="headline">Bank Users</h4>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12 sm4>
        <v-card>
          <v-list three-line dense class="transparent">
            <template v-for="user in users">
              <v-list-item
                :key="`list-${user.id}`"
                @click="selectUser(user)"
                :class="{ 'primary--text': isActiveUser(user.id) }"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ user.full_name }}</v-list-item-title>
                  <v-list-item-subtitle class="text--primary">{{ user.email }}</v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <strong>Last login: </strong>
                    {{ lastLogin(user) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`divider-${user.id}`" class="ml-3 mr-3"></v-divider>
            </template>
            <v-list-item>
              <v-list-item-content>
                <v-btn color="accent" @click="showNewUser = true">Add new user</v-btn>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 sm8>
        <v-card>
          <v-toolbar flat color="white" class="pl-3">
            <v-toolbar-title>{{ selectedUser.full_name }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-form>
                <v-layout wrap>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.first_name" label="First name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.last_name" label="Last name"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.email" label="Email"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field v-model="updateUser.phone" label="Phone"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions class="ml-4 mr-4 pb-4">
            <v-btn color="accent" text @click="sendWelcomeMessage">Send Welcome Email</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="accent" @click="updateSelectedUser()">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <new-user-dialog
      :show.sync="showNewUser"
      :selectedBusinessId="SelectedBank.id"
      :selectedBusinessName="SelectedBank.name"
      @success="refreshBank"
    ></new-user-dialog>
  </abf-container>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import NewUserDialog from '../Funders/NewUserDialog';
import AbfContainer from '../../Abf/AbfContainer';

export default {
  components: {
    AbfContainer,
    NewUserDialog
  },
  name: 'bank-users',
  data: () => ({
    showNewUser: false,
    users: [],
    selectedUser: {},
    updateUser: {}
  }),
  computed: {
    ...mapGetters(['SelectedBank', 'UILeftDrawer', 'PlatformUser', 'UserHasRole']),
    screenIsWideEnough: function() {
      return this.$vuetify.breakpoint.width > 1600;
    }
  },
  methods: {
    ...mapActions([
      'getReferrals',
      'setReferrerId',
      'updateBankUser',
      'sendBankWelcomeMessage',
      'addNotification',
      'selectBank'
    ]),
    selectUser: function(user) {
      this.selectedUser = user;
      this.updateUser = _.clone(user);
    },
    isActiveUser(id) {
      return id === this.selectedUser.id;
    },
    lastLogin(user) {
      if (user.last_logged_in_at) {
        return this.$moment().calendar(user.last_logged_in_at);
      }
      return 'Never';
    },
    updateSelectedUser() {
      const updates = this.diff(this.updateUser, this.selectedUser);
      this.updateBankUser({ id: this.selectedUser.id, updates }).then(() => {
        this.addNotification({
          text: `${this.selectedUser.full_name} user details updated`
        });
      });
    },
    sendWelcomeMessage() {
      this.sendBankWelcomeMessage(this.selectedUser.id).then(() => {
        this.addNotification({
          text: `${this.selectedUser.full_name}: password reset and welcome message sent`
        });
      });
    },
    refreshBank() {
      this.addNotification({
        text: `User added - please refresh to see details`
      });
      this.selectBank(this.SelectedBank.id);
    },
    diff(object, base) {
      function changes(object, base) {
        return _.transform(object, (result, value, key) => {
          if (!_.isEqual(value, base[key])) {
            result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
          }
        });
      }

      return changes(object, base);
    }
  },
  watch: {
    SelectedBank: {
      immediate: true,
      handler() {
        this.users = this.SelectedBank.users;
        this.selectedUser = this.SelectedBank.users[0];
        this.updateUser = _.clone(this.SelectedBank.users[0]);
      }
    }
  }
};
</script>
